import React from 'react';
import { siteData } from '../mock';

const About = () => {
  return (
    <section id="about" className="py-20 lg:py-32 bg-black relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-64 h-64 border border-pink-accent opacity-10 rounded-full blur-sm"></div>
      <div className="grain-overlay opacity-30"></div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-6xl mx-auto">
          <h2 className="section-heading mb-8 lg:mb-12 text-center">
            {siteData.about.title}
          </h2>
          
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-16">
            <div className="space-y-6">
              <p className="body-large leading-relaxed">
                {siteData.about.description}
              </p>
              <div className="h-1 w-24 bg-pink-accent"></div>
            </div>
            
            <div className="grid grid-cols-2 gap-6">
              {siteData.about.stats.map((stat, index) => (
                <div 
                  key={index}
                  className="stat-card p-6 bg-white bg-opacity-5 backdrop-blur-sm border border-white border-opacity-10 rounded-lg hover:border-pink-accent hover:border-opacity-50 transition-all duration-300"
                >
                  <div className="text-4xl lg:text-5xl font-bold text-pink-accent mb-2">
                    {stat.value}
                  </div>
                  <div className="text-sm lg:text-base text-white opacity-70 uppercase tracking-wider font-mono">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Philosophy Section */}
          <div className="bg-gradient-to-r from-transparent via-pink-accent via-opacity-5 to-transparent p-px rounded-lg">
            <div className="bg-black p-8 lg:p-12 rounded-lg">
              <h3 className="text-2xl lg:text-3xl font-bold mb-6 text-center">
                The Biggie Philosophy
              </h3>
              <div className="grid md:grid-cols-3 gap-8 text-center">
                <div>
                  <div className="text-5xl mb-4">🎨</div>
                  <h4 className="text-xl font-bold mb-2 text-pink-accent">Create Fearlessly</h4>
                  <p className="text-sm opacity-80">No boundaries, no limits—just raw creative energy</p>
                </div>
                <div>
                  <div className="text-5xl mb-4">🔗</div>
                  <h4 className="text-xl font-bold mb-2 text-pink-accent">Build Community</h4>
                  <p className="text-sm opacity-80">Web3 is about people, not just technology</p>
                </div>
                <div>
                  <div className="text-5xl mb-4">🚀</div>
                  <h4 className="text-xl font-bold mb-2 text-pink-accent">Push Forward</h4>
                  <p className="text-sm opacity-80">Innovation thrives on experimentation and chaos</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
